var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 3.33333C2.66675 3.15652 2.73699 2.98695 2.86201 2.86193C2.98703 2.7369 3.1566 2.66666 3.33341 2.66666H12.6667C12.8436 2.66666 13.0131 2.7369 13.1382 2.86193C13.2632 2.98695 13.3334 3.15652 13.3334 3.33333V4.66666C13.3334 4.84348 13.2632 5.01304 13.1382 5.13807C13.0131 5.26309 12.8436 5.33333 12.6667 5.33333H3.33341C3.1566 5.33333 2.98703 5.26309 2.86201 5.13807C2.73699 5.01304 2.66675 4.84348 2.66675 4.66666V3.33333ZM2.66675 8.66666C2.66675 8.48985 2.73699 8.32028 2.86201 8.19526C2.98703 8.07024 3.1566 8 3.33341 8H7.33341C7.51023 8 7.6798 8.07024 7.80482 8.19526C7.92984 8.32028 8.00008 8.48985 8.00008 8.66666V12.6667C8.00008 12.8435 7.92984 13.013 7.80482 13.1381C7.6798 13.2631 7.51023 13.3333 7.33341 13.3333H3.33341C3.1566 13.3333 2.98703 13.2631 2.86201 13.1381C2.73699 13.013 2.66675 12.8435 2.66675 12.6667V8.66666ZM10.6667 8.66666C10.6667 8.48985 10.737 8.32028 10.862 8.19526C10.987 8.07024 11.1566 8 11.3334 8H12.6667C12.8436 8 13.0131 8.07024 13.1382 8.19526C13.2632 8.32028 13.3334 8.48985 13.3334 8.66666V12.6667C13.3334 12.8435 13.2632 13.013 13.1382 13.1381C13.0131 13.2631 12.8436 13.3333 12.6667 13.3333H11.3334C11.1566 13.3333 10.987 13.2631 10.862 13.1381C10.737 13.013 10.6667 12.8435 10.6667 12.6667V8.66666Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateOutline);
export default __webpack_public_path__ + "static/media/TemplateOutline.57904b804db47c4000aaa2b587acd959.svg";
export { ForwardRef as ReactComponent };